import {Heading} from "../Heading";
import React from "react";

interface Props {
    className?: string;
    stepNumber?: React.ReactNode;
    stepDescription?: React.ReactNode;
    stepDescriptionSM?: React.ReactNode;
}

export default function Activation({
                                       stepNumber = "01",
                                       stepDescription = "Регистрируетесь в личном кабинете",
                                       stepDescriptionSM = "Регистрируетесь в личном кабинете",
                                       ...props
                                   }: Props) {
    return (
        <div {...props} className={`${props.className} flex flex-col items-start w-full`}>
            <Heading
                size="desktop_numeric_xl_bold"
                as="h1"
                className=" text-[#FF573A] font-bold whitespace-pre-line">
                {stepNumber}
            </Heading>
            <Heading
                size="desktop_heading_6"
                className="md:hidden sm:hidden text-[#E9E9E9] font-medium uppercase whitespace-pre-line">
                {stepDescription}
            </Heading>
            {/*--------------*/}
            <Heading
                size="desktop_body_xl"
                className="lg:hidden sm:hidden text-[#E9E9E9] font-medium whitespace-pre-line">
                {stepDescription}
            </Heading>
            {/*--------------*/}
            <Heading
                size="desktop_body_s"
                className="lg:hidden md:hidden text-[#E9E9E9] font-medium overflow-hidden whitespace-pre-line h-[60px] line-clamp-3"
            >
                {stepDescriptionSM}
            </Heading>
        </div>
    )
}